import { type TouchThreshold } from 'touch-behavior';

export const TOUCH_THRESHOLD: TouchThreshold = {
    swipe: 3, // minimum displacement (x) before triggering swipe stages
    action: 56, // minimum displacement (x) required to trigger an action (delete/mark-as-read) on touch end
    edgeSwipe: 15, // prevent unintentional swipes/touches. Minimum threshold for a swipe (left/right) action is registered
    longPress: -1,
};
